import NewPostNotification from './components/NewPostNotification';
import SubscriptionMenu from './components/SubscriptionMenu';
import SubscriptionMenuItem from './components/SubscriptionMenuItem';

export default {
  'subscriptions/components/NewPostNotification': NewPostNotification,
  'subscriptions/components/SubscriptionMenu': SubscriptionMenu,
  'subscriptions/components/SubscriptionMenuItem': SubscriptionMenuItem,
};
